import React from "react";
import { Checkbox, FormControlLabel, TextField, Stack } from "@mui/material";

export const ScheduleComponents = ({
  scheduleLater,
  setScheduleLater,
  scheduledDate,
  setScheduledDate,
  scheduledTime,
  setScheduledTime,
}) => {
  // Disable inputs if scheduling is off
  const isSchedulingDisabled = scheduleLater !== 1;

  // Get today's date in YYYY-MM-DD
  const today = new Date();
  const todayStr = today.toISOString().split("T")[0];

  // Get current time in HH:mm (24h) - no seconds for display
  const pad = (n) => String(n).padStart(2, "0");
  const currentTime = `${pad(today.getHours())}:${pad(today.getMinutes())}`;
  const minTime = scheduledDate === todayStr ? currentTime : "00:00";

  // Handle time change - convert HH:MM to HH:MM:SS
  const handleTimeChange = (e) => {
    const timeValue = e.target.value; // This will be in HH:MM format
    if (timeValue) {
      const timeWithSeconds = `${timeValue}:00`; // Add :00 seconds
      setScheduledTime(timeWithSeconds);
    } else {
      setScheduledTime("");
    }
  };

  // Display value - remove seconds for the input field
  const displayTime = scheduledTime ? scheduledTime.substring(0, 5) : "";

  return (
    <Stack spacing={2}>
      {/* Checkbox */}
      <FormControlLabel
        control={
          <Checkbox
            checked={scheduleLater === 1}
            onChange={(e) => setScheduleLater(e.target.checked ? 1 : 0)}
          />
        }
        label="Schedule for later"
      />

      {/* Date & Time Pickers Side by Side */}
      <Stack direction="row" spacing={2}>
        <TextField
          type="date"
          label="Date"
          value={scheduledDate || ""}
          onChange={(e) => setScheduledDate(e.target.value)}
          fullWidth
          disabled={isSchedulingDisabled}
          inputProps={{ min: todayStr }}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          type="time"
          label="Time"
          value={displayTime} // 👈 Show HH:MM format
          onChange={handleTimeChange} // 👈 Store as HH:MM:SS
          fullWidth
          disabled={isSchedulingDisabled}
          inputProps={{
            min: minTime,
            step: 60, // 👈 Minute-level precision
          }}
          InputLabelProps={{ shrink: true }}
        />
      </Stack>
    </Stack>
  );
};
